// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-identitypickerdropdown-callout-content {
  border-radius: 4px;
  min-width: 296px;
  overflow: hidden;
}

.bolt-identitypickerdropdown-input {
  background: transparent;
}

.bolt-identitypickerdropdown-item :hover .bolt-contact-card-button,
.bolt-identitypickerdropdown-item :focus .bolt-contact-card-button, .bolt-identitypickerdropdown-item.bolt-suggestions-isSuggested .bolt-contact-card-button {
  display: flex;
}
@media (forced-colors: active) {
  .bolt-identitypickerdropdown-item .bolt-picker-suggesteditem-text {
    forced-color-adjust: none;
    background-color: window;
    border: 1px solid Highlight;
    color: windowtext;
  }
}
.bolt-identitypickerdropdown-item .bolt-contact-card-button {
  display: none;
}

.bolt-identitypickerdropdown-noresults {
  background-color: rgba( 248, 248, 248 ,  1 );
  background-color: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
  border-radius: 4px;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  font-size: 0.75rem;
  height: 32px;
  padding: 4px 3px;
}
@media (forced-colors: active) {
  .bolt-identitypickerdropdown-noresults {
    border: 1px solid Highlight;
  }
}

.bolt-picker-persona {
  margin-right: 4px;
  min-width: 24px;
  min-height: 24px;
}

.bolt-picker-persona-name {
  margin-left: 4px;
  overflow: hidden;
}

.bolt-identitypicker-github-icon {
  font-size: 0.75rem;
  margin-right: 4px;
}

/*# sourceMappingURL=IdentityPickerSuggestionsList.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/IdentityPickerSuggestionsList/IdentityPickerSuggestionsList.scss","webpack://./../azure-devops-ui/bin/Components/IdentityPickerSuggestionsList/IdentityPickerSuggestionsList.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAQA;EACI,kBAAA;EACA,gBAJW;EAKX,gBAAA;ACPJ;;ADUA;EACI,uBAAA;ACPJ;;ADcQ;;EACI,aAAA;ACVZ;ACkCI;EFpBA;IAEQ,yBAAA;IACA,wBAAA;IACA,2BAAA;IACA,iBAAA;ECZV;AACF;ADeI;EACI,aAAA;ACbR;;ADiBA;EACI,4CGkDQ;EHjDR,qEAAA;EACA,kBGiHW;EHhHX,wBG6NO;EH5NP,kDA1CY;EA2CZ,kBAAA;ECdF,YAAY;ECcV,gBAAA;ADZJ;AACA;EACE;IACE,2BAA2B;EAC7B;ADeF;;ACZA;EDeI,iBAvDiB;EC0CnB,eAAe;EACf,gBAAgB;ADelB;;ACZA;EACE,gBAAgB;EAChB,gBAAgB;ADelB;;ACZA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4DAA4D","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
